import { Injectable } from '@angular/core';

import { ConfigDto } from './tables/dto/table-details-dto';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly STORAGE_KEY = 'config';

  /**
   * Liga o modo garcom/landscape inteiro em dev sem precisar redimensionar o viewport.
   * Em producao, deixar false — o modo ativa sozinho em tablet landscape.
   */
  private readonly FORCE_LANDSCAPE_TABLET = false;

  private readonly TABLET_LANDSCAPE_QUERY = '(orientation: landscape) and (min-width: 768px)';

  constructor(private localStorageService: LocalStorageService) {}

  isEnabled(name: string): boolean {
    const config = this.find(name);
    return config?.valor == 'true' || config?.valor == '1';
  }

  /**
   * Ponto unico de verdade do modo landscape/garcom: controla CSS, pagamento PIX
   * direto na home, bypass de autenticacao e exibicao do QR code.
   * Ativa por viewport de tablet landscape (sem flag de backend).
   */
  isLandscapeTabletEnabled(): boolean {
    return this.FORCE_LANDSCAPE_TABLET || this.isTabletLandscapeViewport();
  }

  getValue(name: string): string | null {
    return this.find(name)?.valor ?? null;
  }

  getAll(): ConfigDto[] {
    return this.localStorageService.getItem<ConfigDto[]>(this.STORAGE_KEY) ?? [];
  }

  private isTabletLandscapeViewport(): boolean {
    return typeof window !== 'undefined'
      && window.matchMedia(this.TABLET_LANDSCAPE_QUERY).matches;
  }

  private find(name: string): ConfigDto | undefined {
    return this.getAll().find(config => config.nome === name);
  }
}
